var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
var DimensioningJobCreateView = /** @class */ (function (_super) {
    __extends(DimensioningJobCreateView, _super);
    function DimensioningJobCreateView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCustomerSelectChange = function (event) {
            var select = event.target;
            _this.toggleCustomerItemImportField(select.value != '');
        };
        _this.onJobCreateFormSubmit = function (event) {
            var submitButton = document.querySelector('#save-job-button');
            submitButton.classList.add('is-loading');
            submitButton.disabled = true;
        };
        _this.toggleCustomerItemImportField = function (isToggled) {
            var fieldEl = document.querySelector('#import-customer-items-field');
            if (isToggled)
                fieldEl.classList.remove('is-hidden');
            else
                fieldEl.classList.add('is-hidden');
        };
        return _this;
    }
    DimensioningJobCreateView.prototype.onMounted = function () {
        document.querySelector('#customer-select').addEventListener('change', this.onCustomerSelectChange);
        document.querySelector('#job-create-form').addEventListener('submit', this.onJobCreateFormSubmit);
    };
    return DimensioningJobCreateView;
}(View));
export default DimensioningJobCreateView;
